export enum ExpensesType {
    MusicalGroup = 1,
    Lighting = 2,
    Fireworks = 3,
    Other = 4,
    MusicSystem = 5,
    License = 6,
    Meal = 7,
    Prize = 8,
    ReligiousExpenses = 9,
    MaterialRental = 10,
    Policing = 11,
    Merchandising = 12,
    Publicity = 13,
    SocialAction = 14,
    CommunityProject = 15,
}
